// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__mT5Mq","tools":"styles_tools__31E-z","icon":"styles_icon__18SrT","exit":"styles_exit__1fQVy"};